import React from 'react';

/**
 * Pill-style toggle for 2+ mutually exclusive options (replaces radio groups / small selects).
 */
export default function AdminSegmentToggle({
  options,
  value,
  onChange,
  disabled = false,
  size = 'sm',
  className = '',
  ariaLabel,
}) {
  const list = Array.isArray(options) ? options : [];
  return (
    <div
      className={`admin-segment-toggle admin-segment-toggle--${size}${className ? ` ${className}` : ''}`}
      role="group"
      aria-label={ariaLabel}
    >
      {list.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            className={`admin-segment-toggle__btn${active ? ' is-active' : ''}`}
            aria-pressed={active}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
